import {
  fetchDetailProduct,
  fetchProductDetailApi,
  ListLicenses,
  ProductAvailableType,
} from 'api/productApi'
import useProductManagement from 'features/productManagement/useProductManagement'
import {dateToDashString} from 'helpers/dateHelper'
import {
  OFFER_TYPE,
  PAYMENT_METHOD,
  USAGE_PERIOD_UNIT,
} from 'pages/ProductsPages/constant'
import useProductUsageHistoryStyles from 'pages/ProductUsageHistory/style'
import React, {useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'

type CardInfoProps = {
  id: string
  item: ListLicenses['items']
  isAdmin?: boolean
  active: boolean
  periodDate: {
    startDate: number
    endDate: number
  }
  handleClick: ({
    item,
    paymentMethod,
    offerType,
  }: {
    item: ListLicenses['items']
    paymentMethod: string
    offerType: string
  }) => void
  onActive: () => void
}

const CardInfo = ({
  id,
  handleClick,
  item,
  isAdmin = false,
  active,
  onActive,
  periodDate,
}: CardInfoProps) => {
  const {t, i18n} = useTranslation()
  const classes = useProductUsageHistoryStyles()
  const [data, setData] = useState<ProductAvailableType | null>(null)
  const {getNameProduct} = useProductManagement()
  const {productName, description} = useMemo(() => {
    let name = ''
    let desc = ''
    if (data) {
      name = !isAdmin
        ? getNameProduct(data.goods.goodsName)?.name || ''
        : getNameProduct(data.goods?.displayInfos || [])?.name || ''
      desc = !isAdmin
        ? getNameProduct(data.goods.goodsName)?.description || ''
        : getNameProduct(data.goods?.displayInfos || [])?.description || ''
    }
    return {productName: name, description: desc}
  }, [data, i18n.language])

  const displayPaymentMethod = useMemo(() => {
    if (!data) return ''
    if (data.sale.paymentMethod === PAYMENT_METHOD.PREPAYMENT) {
      if (data.offer.offerType === OFFER_TYPE.ONCE) {
        return t('IUpfrontPlanMethod')
      }
      return t('IMonthlyPlanMethod')
    }
    return t('IManualPaid')
  }, [data, i18n.language])

  useEffect(() => {
    const generateDetail = async () => {
      const res = !isAdmin
        ? await fetchDetailProduct(id)
        : await fetchProductDetailApi({goodsId: id})
      setData(res.data as ProductAvailableType)
    }
    generateDetail()
  }, [])

  useEffect(() => {
    if (active) {
      handleClick({
        item,
        paymentMethod: data?.sale.paymentMethod ?? '',
        offerType: data?.offer.offerType ?? '',
      })
    }
  }, [item, active])

  return (
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    <div
      onClick={onActive}
      className={`${classes.infoProduct} ${
        active ? classes.infoProductActive : ''
      }`}
    >
      <div className={classes.productTitle}>{productName}</div>
      <div className={classes.productType}>
        {t('IType')}: {displayPaymentMethod}
      </div>
      <div>
        {t('IPeriod')}:{' '}
        {data && data.offer.usagePeriodUnit === USAGE_PERIOD_UNIT.LIFETIME
          ? t('IUnlimited')
          : `${dateToDashString(
              new Date(periodDate.startDate),
            )} ~ ${dateToDashString(new Date(periodDate.endDate))}`}
      </div>
      <div>
        {t('IDescription')}: {description}
      </div>
    </div>
  )
}

export default CardInfo
